import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

import instapayQRLogo from './../../../../../../statics/img/instapay/instapay_qr_logo.png';
import RequestPay from '../RequestPay';
import { msToTime } from '../../../../../../utils/msToTime';

function QRMethod(props) {
  const {
    onInquiry,
    isInquiring,
    paymentData,
    timer,
    isLoading,
    onOpenCancelModal,
  } = props;

  return (
    <RequestPay
      onInquiry={onInquiry}
      isInquiring={isInquiring}
      isLoading={isLoading}
      onOpenCancelModal={onOpenCancelModal}
    >
      <div className="instapay_mb-1">
        <QRCodeSVG
          value={paymentData.qr_code}
          size={150}
          imageSettings={{
            src: instapayQRLogo,
            height: 24,
            width: 48,
            excavate: true,
          }}
        />
      </div>

      <div className="instapay_request_header_support">
        <p className="instapay_request_header_support-dark-text instapay_mb-1">
          Scan the code with your mobile camera
        </p>
        <p className="instapay_request_header_support-light-text">
          Please complete the transaction in <span className='instapay_highlight'>{msToTime(timer)}</span>{' '}
          {timer < 60000 ? 'seconds' : 'minutes'}
        </p>
      </div>
    </RequestPay>
  );
}

export default QRMethod;
